import React, { Component } from "react";
import { Modal, Icon, Segment } from "semantic-ui-react";
import mixpanel from "../../services/mixpanel";
import { connectSaga } from "../../util/hoc/connectSaga";
import { watchAddToCollectionModalRequests } from "./sagas";
import CollectionsList from "../../scenes/CollectionsPage/components/CollectionsList";
import Collection from "./components/Collection";
import OverlayLoader from "../../components/OverlayLoader";
import "./index.css";
import { connect } from "react-redux";
import {
  closeAddToCollectionModal,
  openNewCollectionFormModal,
  addPostToCollection,
} from "../../actions/collectionActions";
import { collectionFormModalTriggerSources } from "../../constants";
import { selectLoggedInUserID } from "../../util/selectors";
import { loadMoreAddToCollectionModalCollections } from "./actions";

class AddToCollectionModal extends Component {
  constructor(props) {
    super(props);
    this.loadMoreLoggedInUserCollections = this.loadMoreLoggedInUserCollections.bind(this);
    this.addPostToCollection = this.addPostToCollection.bind(this);
    this.openNewCollectionModal = this.openNewCollectionModal.bind(this);
  }

  loadMoreLoggedInUserCollections() {
    const { userId, addToCollectionModalState: { collections, postId } } = this.props;
    const pagingToken = collections && collections.pagingToken;
    this.props.actions.loadMoreAddToCollectionModalCollections({ userId, pagingToken, selectedPost: postId });
  }

  addPostToCollection(collectionId) {
    this.props.actions.addPostToCollection({ postId: this.props.addToCollectionModalState.postId, collectionId });
  }

  openNewCollectionModal() {
    this.props.actions.closeModal();
    this.props.actions.openNewCollectionModal(collectionFormModalTriggerSources.ADD_TO_COLLECTION_MODAL);
    mixpanel.track("addNewCollection");
  }

  render() {
    const {
      actions: { closeModal },
      addToCollectionModalState: { collections, isAddingPostToCollection },
    } = this.props;
    return (
      <Modal size="mini" open closeOnRootNodeClick={false} onClose={closeModal}>
        <div className="modal-container">
          <div className="header">
            <span className="message"> Add to collection </span>
            <Icon name="close" size="large" className="closebtn" onClick={closeModal} />
          </div>

          <div className="collections">
            {isAddingPostToCollection && <OverlayLoader size="medium" />}
            <CollectionsList
              collections={collections}
              loadMoreCollections={this.loadMoreLoggedInUserCollections}
              collectionProps={{
                addPostToCollection: this.addPostToCollection,
              }}
              collectionComponent={Collection}
              infiniteScrollerProps={{
                threshold: 20,
                useWindow: false,
                loader: (
                  <div className="loader">
                    <Segment basic loading size="small" inline="centered" />
                  </div>
                ),
              }}
            />
          </div>

          <a className="new-collection" onClick={this.openNewCollectionModal}>
            <Icon name="plus" className="icon" />
            <span>Add new collection</span>
          </a>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  addToCollectionModalState: state.ui.addToCollectionModal,
  userId: selectLoggedInUserID(state),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    closeModal: () => dispatch(closeAddToCollectionModal()),
    loadMoreAddToCollectionModalCollections: (...props) => dispatch(loadMoreAddToCollectionModalCollections(...props)),
    addPostToCollection: (...props) => dispatch(addPostToCollection(...props)),
    openNewCollectionModal: (...props) => dispatch(openNewCollectionFormModal(...props)),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  connectSaga(AddToCollectionModal, watchAddToCollectionModalRequests)
);



// WEBPACK FOOTER //
// ./src/components/AddToCollectionModal/index.js